import { render, staticRenderFns } from "./businessReport.vue?vue&type=template&id=d0284aaa&scoped=true&"
import script from "./businessReport.vue?vue&type=script&lang=js&"
export * from "./businessReport.vue?vue&type=script&lang=js&"
import style0 from "./businessReport.vue?vue&type=style&index=0&id=d0284aaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0284aaa",
  null
  
)

export default component.exports